import React, { useState } from "react";

import {
  ActionIcon,
  Flex,
  Menu,
  Table,
  Text,
  Title,
} from "@mantine/core";
import { IconUpload, IconFolderSymlink } from "@tabler/icons-react";
import moment from "moment";
import { useDisclosure } from "@mantine/hooks";
import { HiOutlineDotsVertical } from "react-icons/hi";
import StaffDeleteFileModal from "./StaffDeleteFileModal";
import StaffOpenFileModal from "./StaffOpenFileModal";
import StaffRenameFileModal from "./StaffRenameFileModal";
import StaffMoveFileModal from "./StaffMoveFileModal";
import RecordNotFound from "../RecordNotFound";
import useStyles from "./style";

function StaffFileItem({ data, userId, userType, selectedFolder, onUploadTemplate }) {
  const { classes } = useStyles();
  const [opened, { open, close }] = useDisclosure(false);
  const [Fileopened, { open: openFile, close: closeFile }] =
    useDisclosure(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [Deleteopened, { open: deleteOpen, close: deleteClose }] =
    useDisclosure(false);
  const [Moveopened, { open: moveOpen, close: moveClose }] =
    useDisclosure(false);

  const hasFile = !!data?.fileUrl;

  let extension =
    data?.fileUrl?.split(".")[data?.fileUrl?.split(".")?.length - 1];
  let imagePath =
    extension === "pdf"
      ? "/assets/images/pdf-svg.png"
      : ["jpeg", "JPEG", "JPG", "PNG", "GIF", "jpg", "png", "gif"].includes(
            extension,
          )
        ? "/assets/images/picture-svg.png"
        : extension === "docx" || extension === "doc"
          ? "/assets/images/doc.png"
          : extension === "xlsx" || extension === "xls"
            ? "/assets/images/xls.png"
            : "/assets/images/document-svg.png";

  return (
    <div
      className={`${classes.folderItem} ${data?.expired === true ? "" : ""}`}
      style={{ opacity: 1 }}
    >
      <div className={classes.column}>
        <div className={classes.verticalIconContainer}>
          <Menu shadow="md" width={200}>
            <Menu.Target>
              <HiOutlineDotsVertical size={20} style={{ cursor: "pointer" }} />
            </Menu.Target>

            <Menu.Dropdown>
              {hasFile ? (
                <>
                  <Menu.Item
                    onClick={() => {
                      setSelectedItem(data);
                      openFile();
                    }}
                    icon={
                      <img
                        src="/assets/images/open.png"
                        alt="open"
                        className={classes.folderMenuIcon}
                      />
                    }
                  >
                    Open
                  </Menu.Item>
                  <Menu.Item
                    onClick={() => {
                      fetch(data?.fileUrl).then((response) => {
                        response.blob().then((blob) => {
                          const fileURL = window.URL.createObjectURL(blob);
                          let alink = document.createElement("a");
                          alink.href = fileURL;
                          alink.download = data?.name;
                          alink.click();
                        });
                      });
                    }}
                    icon={
                      <img
                        src="/assets/images/downloadFolder.png"
                        alt="download"
                        className={classes.folderMenuIcon}
                      />
                    }
                  >
                    Download
                  </Menu.Item>
                  <Menu.Item
                    onClick={() => {
                      setSelectedItem(data);
                      open();
                    }}
                    icon={
                      <img
                        src="/assets/images/editFolder.png"
                        alt="edit"
                        className={classes.folderMenuIcon}
                      />
                    }
                  >
                    Rename
                  </Menu.Item>
                  <Menu.Item
                    onClick={() => {
                      setSelectedItem(data);
                      moveOpen();
                    }}
                    icon={<IconFolderSymlink size={16} />}
                  >
                    Move to Folder
                  </Menu.Item>
                  <Menu.Item
                    onClick={() => {
                      deleteOpen();
                      setSelectedItem(data);
                    }}
                    icon={
                      <img
                        src="/assets/images/deleteFolder.png"
                        alt="delete"
                        className={classes.folderMenuIcon}
                      />
                    }
                    style={{ color: "red" }}
                  >
                    Delete
                  </Menu.Item>
                </>
              ) : (
                <Menu.Item
                  icon={<IconUpload size={16} />}
                  onClick={() => onUploadTemplate && onUploadTemplate(data)}
                >
                  Upload
                </Menu.Item>
              )}
            </Menu.Dropdown>
          </Menu>
        </div>

        <div
          className={classes.filePreview}
          onClick={() => {
            if (hasFile) {
              setSelectedItem(data);
              openFile();
            } else if (onUploadTemplate) {
              onUploadTemplate(data);
            }
          }}
        >
          <img src={imagePath} className={classes.folderBig} alt="folder" />
        </div>
      </div>
      <Flex direction={"column"} align={"center"} justifyContent={"center"}>
        <Title order={5}>
          {data?.name?.length > 14
            ? data?.name?.slice(0, 14) + "..."
            : data?.name}
        </Title>

        {hasFile ? (
          <Text
            className={classes.folderDateText}
            fz="xs"
            weight={"bolder"}
          >
            {moment(data?.createdAt).format("MMMM DD, YYYY")}
          </Text>
        ) : (
          <Text fz="xs" weight={"bolder"} color="dimmed">
            Empty
          </Text>
        )}

        {data?.expired === true && moment(data?.expiry).isValid() ? (
          <Text className={classes.expiryDateText} fz="xs" weight={"bolder"}>
            Expired: {moment(data?.expiry).format("MMMM DD, YYYY")}
          </Text>
        ) : (
          data?.expiry &&
          moment(data?.expiry).isValid() && (
            <Text className={classes.expiryDateText} fz="xs" weight={"bolder"}>
              Expiry: {moment(data?.expiry).format("MMMM DD, YYYY")}
            </Text>
          )
        )}
      </Flex>

      <StaffRenameFileModal
        opened={opened}
        onclose={close}
        title={"Rename File"}
        data={selectedItem}
        userId={userId}
        userType={userType}
        currentFolderId={selectedFolder?._id || selectedFolder?.id}
      />
      <StaffMoveFileModal
        opened={Moveopened}
        onclose={moveClose}
        title={"Move to Folder"}
        data={selectedItem}
        userId={userId}
        userType={userType}
        currentFolderId={selectedFolder?._id || selectedFolder?.id}
      />
      <StaffOpenFileModal
        opened={Fileopened}
        onclose={closeFile}
        title={""}
        data={selectedItem}
      />
      <StaffDeleteFileModal
        opened={Deleteopened}
        onclose={deleteClose}
        title={"Delete File"}
        data={selectedItem}
        userId={userId}
        userType={userType}
        currentFolderId={selectedFolder?._id || selectedFolder?.id}
      />
    </div>
  );
}

// const StaffFileTable = ({ data, client }) => {
//   const { classes } = useStyles();
//   const [opened, { open, close }] = useDisclosure(false);
//   const [selectedItem, setSelectedItem] = useState(null);
//   const [Fileopened, { open: openFile, close: closeFile }] =
//     useDisclosure(false);
//   const [Deleteopened, { open: deleteOpen, close: deleteClose }] =
//     useDisclosure(false);

//     data.forEach((item) => {
//       const extension = item?.fileUrl?.split(".").pop().toLowerCase(); // Get extension and normalize

//       const imagePath =
//         extension === "pdf"
//           ? "/assets/images/pdf-svg.png"
//           : ["jpeg", "jpg", "png", "gif"].includes(extension)
//           ? "/assets/images/picture-svg.png"
//           : ["docx", "doc"].includes(extension)
//           ? "/assets/images/doc.png"
//           : ["xlsx", "xls"].includes(extension)
//           ? "/assets/images/xls.png"
//           : "/assets/images/document-svg.png";

//     });

//   //   let extension =
//   //   data?.fileUrl?.split(".")[data?.fileUrl?.split(".")?.length - 1];
//   // let imagePath =
//   //   extension === "pdf"
//   //     ? "/assets/images/pdf-svg.png"
//   //     : ["jpeg", "JPEG", "JPG", "PNG", "GIF", "jpg", "png", "gif"].includes(
//   //         extension
//   //       )
//   //     ? "/assets/images/picture-svg.png"
//   //     : extension === "docx" || extension === "doc"
//   //     ? "/assets/images/doc.png"
//   //     : extension === "xlsx" || extension === "xls"
//   //     ? "/assets/images/xls.png"
//   //     : "/assets/images/document-svg.png";

//   const ths = (
//     <tr>
//       <th style={{ minWidth: "400px" }}>Name</th>
//       <th style={{ minWidth: "200px" }}>Date</th>
//       <th style={{ minWidth: "200px" }}>Expiry Date</th>
//       {/* <th style={{ minWidth: "150px" }}>File Extension</th> */}
//       {/* <th style={{ minWidth: "250px" }}>Location</th> */}
//       {/* <th style={{ minWidth: "250px" }}>Actions</th> */}
//     </tr>
//   );
//   return (
//     <>
//       {data?.length > 0 ? (
//         <Table striped fontSize={"md"}>
//           <thead>{ths}</thead>
//           <tbody>
//             {data?.map((val, index) => (
//               <tr key={val?._id}>
//                 <td>
//                   <div className={classes.imgName}>
//                     <img
//                       src={imagePath}
//                       alt="file"
//                       className={classes.fileImageRow}
//                     />{" "}
//                     <p>{val?.name}</p>
//                     {/* <ActionIcon
//                       color="yellow"
//                       variant="light"
//                       onClick={(e) => {
//                         setSelectedItem(val);
//                         open(e);
//                       }}
//                     >
//                       <IconEdit />
//                     </ActionIcon> */}
//                   </div>
//                 </td>
//                 {/* <td>
//                   {val?.fileUrl
//                     ?.split(".")
//                     [val?.fileUrl?.split(".")?.length - 1]?.toUpperCase()}
//                 </td> */}
//                 <td>{`${moment(val?.createdAt).format("MM/DD/YYYY")}`}</td>
//                 <td className={classes.expiryDateText}>
//                   {val?.expiry
//                     ? `${moment(val?.expiry).format("MM/DD/YYYY")}`
//                     : "-"}
//                 </td>
//                 {/* <td>{val?.folder ? val?.folder?.name : "-"}</td>
//                 <td>
//                   <div className={classes.row} style={{ gap: 5 }}>
//                     <img
//                       onClick={() => {
//                         setSelectedItem(val);
//                         openFile();
//                       }}
//                       src="/assets/images/eye.png"
//                       alt="view"
//                       style={{ width: 30, cursor: "pointer" }}
//                     />
//                     <img
//                       onClick={() => {
//                         fetch(val?.fileUrl).then((response) => {
//                           response.blob().then((blob) => {
//                             const fileURL = window.URL.createObjectURL(blob);
//                             let alink = document.createElement("a");
//                             alink.href = fileURL;
//                             alink.download = val?.name;
//                             alink.click();
//                           });
//                         });
//                       }}
//                       src="/assets/images/downloadFile.png"
//                       alt="download"
//                       className={classes.actionsImageRow}
//                     />
//                     <img
//                       onClick={async () => {
//                         setSelectedItem(val);
//                         deleteOpen();
//                       }}
//                       src="/assets/images/deleteFolder.png"
//                       alt="delete"
//                       style={{ width: 30, cursor: "pointer" }}
//                     />
//                   </div>
//                 </td> */}
//               </tr>
//             ))}
//           </tbody>
//         </Table>
//       ) : (
//         <div
//           style={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             justifyContent: "space-evenly",
//             height: "60vh",
//             gap: "8rem",
//             textAlign: "center",
//             margin: "0 auto",
//           }}
//         >
//           <RecordNotFound />
//           <p className={classes.notFoundText}>
//             You don&apos;t have any files uploaded to this folder, click on
//             "upload documents" to add.
//           </p>
//         </div>
//       )}
//       <StaffRenameFileModal
//         opened={opened}
//         onclose={() => {
//           close();
//         }}
//         title={"Rename File"}
//         data={selectedItem}
//         client={client}
//       />
//       <StaffOpenFileModal
//         opened={Fileopened}
//         onclose={() => {
//           closeFile();
//         }}
//         title={""}
//         data={selectedItem}
//       />
//       <StaffDeleteFileModal
//         opened={Deleteopened}
//         onclose={() => {
//           deleteClose();
//         }}
//         title={"Delete File"}
//         data={selectedItem}
//         client={client}
//       />
//     </>
//   );
// };

const BADGE_STYLES = {
  empty: { background: "var(--app-surface-2)", color: "var(--app-text-muted)" },
  uploaded: { background: "var(--app-tint-green)", color: "#065F46" },
  expiring: { background: "var(--app-tint-amber)", color: "#92400E" },
  expired: { background: "var(--app-tint-red)", color: "#991B1B" },
};

const BADGE_LABELS = {
  empty: "Empty",
  uploaded: "Uploaded",
  expiring: "Expiring",
  expired: "Expired",
};

const StaffFileTable = ({ data, client, userId, userType, selectedFolder, onUploadTemplate }) => {
  const { classes } = useStyles();
  const [opened, { open, close }] = useDisclosure(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [Fileopened, { open: openFile, close: closeFile }] =
    useDisclosure(false);
  const [Deleteopened, { open: deleteOpen, close: deleteClose }] =
    useDisclosure(false);
  const [Moveopened, { open: moveOpen, close: moveClose }] =
    useDisclosure(false);

  const getFileExtension = (val) => {
    if (!val?.fileUrl) return null;
    return val.fileUrl.split(".").pop().toUpperCase();
  };

  const getImagePath = (val) => {
    if (!val?.fileUrl) return "/assets/images/document-svg.png";
    const ext = val.fileUrl.split(".").pop().toLowerCase();
    if (ext === "pdf") return "/assets/images/pdf-svg.png";
    if (["jpeg", "jpg", "png", "gif"].includes(ext))
      return "/assets/images/picture-svg.png";
    if (["docx", "doc"].includes(ext)) return "/assets/images/doc.png";
    if (["xlsx", "xls"].includes(ext)) return "/assets/images/xls.png";
    return "/assets/images/document-svg.png";
  };

  const getStatus = (val) => {
    if (!val?.fileUrl) return "empty";
    if (val?.expired) return "expired";
    if (val?.expiry && moment(val.expiry).diff(moment(), "days") <= 30)
      return "expiring";
    return "uploaded";
  };

  const renderStatusBadge = (status) => {
    const style = BADGE_STYLES[status];
    if (!style) return null;
    return (
      <span
        style={{
          padding: "2px 10px",
          borderRadius: 12,
          fontSize: 12,
          fontWeight: 600,
          ...style,
        }}
      >
        {BADGE_LABELS[status]}
      </span>
    );
  };

  const handleDownload = (val) => {
    fetch(val?.fileUrl).then((response) => {
      response.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        const alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = val?.name;
        alink.click();
      });
    });
  };

  return (
    <>
      {data?.length > 0 ? (
        <Table striped fontSize="md">
          <thead>
            <tr>
              <th style={{ width: "20%" }}>File Name</th>
              <th style={{ width: "12%" }}>File Extension</th>
              <th style={{ width: "22%" }}>File Description</th>
              <th style={{ width: "13%" }}>Added Date</th>
              <th style={{ width: "13%" }}>Expiration Date</th>
              <th style={{ width: "10%" }}>Status</th>
              <th style={{ width: "10%" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((val) => {
              const status = getStatus(val);
              const hasFile = !!val?.fileUrl;

              return (
                <tr
                  key={val?._id}
                  style={{ opacity: status === "expired" ? 0.6 : 1 }}
                >
                  <td>
                    <div className={classes.imgName}>
                      <img
                        src={getImagePath(val)}
                        alt="file"
                        className={classes.fileImageRow}
                      />
                      <p>{hasFile ? val?.name : "-"}</p>
                    </div>
                  </td>
                  <td>{getFileExtension(val) || "-"}</td>
                  <td>{val?.fileDescription || val?.name || "-"}</td>
                  <td>
                    {hasFile
                      ? moment(val?.createdAt).format("MM/DD/YYYY")
                      : "-"}
                  </td>
                  <td className={classes.expiryDateText}>
                    {val?.expiry
                      ? moment(val?.expiry).format("MM/DD/YYYY")
                      : "-"}
                  </td>
                  <td>{renderStatusBadge(status)}</td>
                  <td>
                    <Menu shadow="md" width={180} position="bottom-end">
                      <Menu.Target>
                        <ActionIcon variant="subtle">
                          <HiOutlineDotsVertical size={18} />
                        </ActionIcon>
                      </Menu.Target>
                      <Menu.Dropdown>
                        {hasFile ? (
                          <>
                            <Menu.Item
                              icon={
                                <img
                                  src="/assets/images/open.png"
                                  alt="open"
                                  style={{ width: 16 }}
                                />
                              }
                              onClick={() => {
                                setSelectedItem(val);
                                openFile();
                              }}
                            >
                              Open
                            </Menu.Item>
                            <Menu.Item
                              icon={
                                <img
                                  src="/assets/images/downloadFolder.png"
                                  alt="download"
                                  style={{ width: 16 }}
                                />
                              }
                              onClick={() => handleDownload(val)}
                            >
                              Download
                            </Menu.Item>
                            <Menu.Item
                              icon={
                                <img
                                  src="/assets/images/editFolder.png"
                                  alt="rename"
                                  style={{ width: 16 }}
                                />
                              }
                              onClick={() => {
                                setSelectedItem(val);
                                open();
                              }}
                            >
                              Rename
                            </Menu.Item>
                            <Menu.Item
                              icon={<IconFolderSymlink size={16} />}
                              onClick={() => {
                                setSelectedItem(val);
                                moveOpen();
                              }}
                            >
                              Move to Folder
                            </Menu.Item>
                            <Menu.Item
                              icon={
                                <img
                                  src="/assets/images/deleteFolder.png"
                                  alt="delete"
                                  style={{ width: 16 }}
                                />
                              }
                              style={{ color: "red" }}
                              onClick={() => {
                                setSelectedItem(val);
                                deleteOpen();
                              }}
                            >
                              Delete
                            </Menu.Item>
                          </>
                        ) : (
                          <Menu.Item
                            icon={<IconUpload size={16} />}
                            onClick={() => onUploadTemplate && onUploadTemplate(val)}
                          >
                            Upload
                          </Menu.Item>
                        )}
                      </Menu.Dropdown>
                    </Menu>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-evenly",
            height: "60vh",
            gap: "8rem",
            textAlign: "center",
            margin: "0 auto",
          }}
        >
          <RecordNotFound />
          <p className={classes.notFoundText}>
            You don&apos;t have any files uploaded to this folder, click on
            &quot;upload documents&quot; to add.
          </p>
        </div>
      )}

      {/* Modals */}
      <StaffRenameFileModal
        opened={opened}
        onclose={close}
        title="Rename File"
        data={selectedItem}
        userId={userId}
        userType={userType}
        currentFolderId={selectedFolder?._id || selectedFolder?.id}
      />
      <StaffMoveFileModal
        opened={Moveopened}
        onclose={moveClose}
        title="Move to Folder"
        data={selectedItem}
        userId={userId}
        userType={userType}
        currentFolderId={selectedFolder?._id || selectedFolder?.id}
      />
      <StaffOpenFileModal
        opened={Fileopened}
        onclose={closeFile}
        title=""
        data={selectedItem}
      />
      <StaffDeleteFileModal
        opened={Deleteopened}
        onclose={deleteClose}
        title="Delete File"
        data={selectedItem}
        userId={userId}
        userType={userType}
        currentFolderId={selectedFolder?._id || selectedFolder?.id}
      />
    </>
  );
};

export { StaffFileItem, StaffFileTable };
